import React from "react";

export const OpenInNew = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="48" width="48" {...props}>
      <path d="M9.9 41q-1.2 0-2.05-.85Q7 39.3 7 38.1V9.9q0-1.2.85-2.05Q8.7 7 9.9 7h11.45q.45 0 .775.325t.325.825q0 .5-.325.8-.325.3-.775.3H9.9q-.25 0-.45.2t-.2.45v28.2q0 .25.2.45t.45.2h28.2q.25 0 .45-.2t.2-.45V26.65q0-.45.325-.775t.775-.325q.5 0 .825.325.325.325.325.775V38.1q0 1.2-.85 2.05-.85.85-2.05.85Zm8.55-11.45q-.35-.3-.375-.75-.025-.45.325-.8L37.15 9.25h-9.5q-.5 0-.825-.325Q26.5 8.6 26.5 8.15q0-.5.325-.825Q27.15 7 27.65 7h11.9q.65 0 1.05.4t.4 1.05v11.9q0 .5-.325.825-.325.325-.825.325-.5 0-.8-.325-.3-.325-.3-.825V10.9L20 29.65q-.3.3-.775.275-.475-.025-.775-.375Z" />
    </svg>
  );
};
